import {
    DestinationEvent,
    FormattedEvent,
    transformDestinationEvent,
} from '@eventbrite/event-renderer';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
    PromotedEventsSearchApiPayload,
    searchPromotedEvents,
} from './searchPromotedEvents';

export type UsePromotedEventsProps = {
    interfaceName: string;
    slots: number;
    search: Pick<PromotedEventsSearchApiPayload, 'search' | 'page'>;
} & ReactQueryExtraOptions;

export type ReactQueryExtraOptions = Omit<
    UseQueryOptions<DestinationEvent[], unknown, FormattedEvent[], any[]>,
    'select' | 'queryKey' | 'queryFn' | 'staleTime'
>;

export function usePromotedEvents({
    search = { search: {}, page: 1 },
    interfaceName,
    slots = 1,
    ...reactQueryProps
}: UsePromotedEventsProps) {
    const apiPayload = { slots, interface: interfaceName, ...search };
    return useQuery({
        queryKey: [interfaceName, 'promoted', apiPayload],
        queryFn: () => searchPromotedEvents(apiPayload),
        staleTime: 0,
        select: (events) => events.map(transformDestinationEvent),
        ...reactQueryProps,
    });
}
